import Link from 'next/link';
import { CardProps } from './types';
import DirectusImage from '../image/DirectusImage';
import CategoryLabel from '../category/CategoryLabel';
import DateLabel from '../date/DateLabel';
import TitleH2 from '../common/TitleH2';
import Paragraph from '../common/Paragraph';
import GalleryIcon from '../../../../public/png/photo_group_icon.png';
import PlayVideoIcon from '../../../../public/svg/play_video.svg';

export default function ImageCard({
  callToActionUrl: { url, external, slug },
  category,
  titleCustomFont = false,
  titleBlockStyles = '',
  displayDescription = true,
  duration,
  image,
  imageAlt,
  stylesImage = 'h-full',
  isoDate,
  title,
  description,
  imageBlur,
  imageHeight = 'h-full',
  imageSizes,
  photoCount = 0,
}: CardProps) {
  const link = external ? url : `${url}/${slug}`;
  const target = external ? '_blank' : '_self';
  const sizes = imageSizes || '100vw';

  return (
    <div className={`card relative flex ${imageHeight} w-full flex-col justify-end`}>
      <Link href={link} target={target} className={`relative ${stylesImage}`}>
        <figure>
          <DirectusImage
            src={image || ''}
            alt={imageAlt || ''}
            blur={imageBlur}
            dimension={{ sizes }}
            styles="rounded-md"
          />
        </figure>

        <div
          className={`absolute bottom-[0px] z-10 flex h-[50%] w-full flex-col items-start justify-end rounded-b-md bg-gradient-to-t from-astro-gradient-start to-astro-gradient-end ${titleBlockStyles ? titleBlockStyles : 'px-11 py-10 xl:py-14'}`}
        >
          <div className="mb-6 flex items-center gap-5">
            {category && <CategoryLabel category={category} type={'blur'} />}
            {isoDate && <DateLabel isoDate={isoDate} type={'since'} styles="text-xs text-white" />}
          </div>
          <TitleH2
            customFont={titleCustomFont}
            titleTracking="tracking-wide"
            heading={false}
            styles=""
          >
            {title}
          </TitleH2>
          {displayDescription && <Paragraph>{description}</Paragraph>}
        </div>
        {duration && (
          <div className="absolute bottom-[20px] right-[20px] z-10 flex max-w-max items-center gap-2.5">
            <DirectusImage
              src={PlayVideoIcon}
              alt="Visionner la galerie video"
              dimension={{ width: 20, height: 20 }}
            />
            <span className="rounded bg-white p-[5px] text-xs font-semibold uppercase text-gray-400 backdrop-blur-sm">
              {duration}
            </span>
          </div>
        )}
        {photoCount > 0 && (
          <div className="absolute bottom-[20px] right-[20px] z-10 flex max-w-max items-center gap-2.5">
            <span className="flex items-center gap-1 rounded bg-white p-[5px] text-xs font-semibold text-gray-400 backdrop-blur-sm">
              <DirectusImage
                src={GalleryIcon}
                alt="Ouvrir la galerie photo"
                dimension={{ width: 10.5, height: 10.25 }}
              />
              {photoCount} photos
            </span>
          </div>
        )}
      </Link>
    </div>
  );
}
